import React from "react";
import {
  Box,
  Button,
  Heading,
  HStack,
  IconButton,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { BsArrowClockwise, BsInfoCircle } from "react-icons/bs";

const ModulePageShell = ({
  title,
  description,
  onRefresh,
  children,
  showGuide,
  onToggleGuide,
  actions,
}) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box p={{ base: 4, md: 6 }}>
      <VStack align="stretch" spacing={4}>
        <HStack justify="space-between" align="flex-start" spacing={3}>
          <Box>
            <Heading size="md">{title}</Heading>
            {description ? (
              <Text mt={1} color="gray.500" fontSize="sm">
                {description}
              </Text>
            ) : null}
          </Box>
          <HStack>
            {actions}
            {onRefresh ? (
              <Button
                size="sm"
                variant="outline"
                leftIcon={<BsArrowClockwise />}
                onClick={onRefresh}
              >
                Refresh
              </Button>
            ) : null}
            {onToggleGuide ? (
              <IconButton
                aria-label="Toggle user guide"
                size="sm"
                variant="outline"
                icon={<BsInfoCircle />}
                onClick={onToggleGuide}
                colorScheme={showGuide ? "blue" : "gray"}
              />
            ) : null}
          </HStack>
        </HStack>

        {showGuide ? (
          <Box bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="lg" p={4}>
            <Text fontWeight="semibold" mb={2}>
              User Guide
            </Text>
            <Text color="gray.600" fontSize="sm">
              Use filters to narrow down data, create records with the quick forms, and use row actions to process workflow steps.
            </Text>
          </Box>
        ) : null}

        {children}
      </VStack>
    </Box>
  );
};

export default ModulePageShell;
